import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useInventoryStore = defineStore('hc-inventory', () => {

    // 格式:
    // product_id1: { stock: number, skuId: number, batchId: number }
    const initialState = {
        inventory: {},
    };

    // Refs mapping
    const state = Object.entries(initialState).reduce((acc, [key, value]) => {
        acc[key] = ref(value);
        return acc;
    }, {});

    const update = (data) => {
        if (data && Object.hasOwn(data, 'productId')) {
            state.inventory.value[data.productId] = data;
        }
    };

    // 從 productId or skuId or batchId 取得值
    const get = (id) => {
        if (Object.hasOwn(state.inventory.value, id)) {
            return state.inventory.value[id];
        }
        //從inventory.skuId or inventory.batchId 取得值
        const item = Object.values(state.inventory.value).find(function (item) {
            if (Object.hasOwn(item, 'skuId') && item.skuId === id
                || Object.hasOwn(item, 'batchId') && item.batchId === id
            ) {
                return item;
            }
        });
        return item ?? null;
    };

    return {
        // 擴充所有狀態
        ...state,
        update, get,
    };
});
